export interface IWeatherData {
  current: {
    temperature: { current: number };
    description: string;
    wind: number;
  };
}

const isWeatherData = (value: unknown): value is IWeatherData => {
  const current = (value as IWeatherData | null)?.current;
  return (
    typeof current?.temperature?.current === 'number' &&
    typeof current?.description === 'string' &&
    typeof current?.wind === 'number'
  );
};

// DailyDto.weather is typed `string` but holds a serialized/persisted IWeatherData
// object (or its JSON form). Normalize either shape to a safe IWeatherData | null.
export const toWeatherData = (value: unknown): IWeatherData | null => {
  let parsed = value;
  if (typeof value === 'string') {
    try {
      parsed = JSON.parse(value);
    } catch {
      return null;
    }
  }
  return isWeatherData(parsed) ? parsed : null;
};
